/** zh-CN catalogue `motion` (W3-09; English: src/features/motion/motion.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'motion',
  locale: 'zh-CN',
  messages: {
    columnTitle: '运动列',
    propMoveX: 'X 位置',
    propMoveY: 'Y 位置',
    propPosition: '位置',
    propRotate: '旋转',
    propAlpha: '不透明度',
    propSpeed: '流速',
    propLength: '长度',
    propThickness: '粗细',
    propSizeX: 'X 尺寸',
    propSizeY: 'Y 尺寸',
    propSize: '尺寸',
    propColor: '颜色',
    propText: '文字',
    propIncline: '倾斜',
    propPaint: '画笔',
    propGif: 'GIF 进度',
    propScaleXAny: '长度 / X 尺寸',
    propScaleYAny: '粗细 / Y 尺寸',
    shortMoveX: 'X 位置',
    shortMoveY: 'Y 位置',
    shortPosition: '位置',
    shortRotate: '旋转',
    shortAlpha: '不透明度',
    shortSpeed: '流速',
    shortLength: '长度',
    shortThickness: '粗细',
    shortSizeX: 'X 尺寸',
    shortSizeY: 'Y 尺寸',
    shortSize: '尺寸',
    shortColor: '颜色',
    shortText: '文字',
    shortIncline: '倾斜',
    shortPaint: '画笔',
    shortGif: 'GIF',
    subX: 'X',
    subY: 'Y',
    subW: 'W',
    subH: 'H',
    subPair: '{a} | {b}',
    columnLabel: '{prop}，{line}',
    columnLabelLayer: '{prop}，层级 {layer}，{line}',
    rpeTermMoveX: 'RPE：moveXEvents',
    rpeTermMoveY: 'RPE：moveYEvents',
    rpeTermRotate: 'RPE：rotateEvents',
    rpeTermAlpha: 'RPE：alphaEvents',
    rpeTermSpeed: 'RPE：speedEvents',
    rpeTermScaleX: 'RPE：scaleXEvents',
    rpeTermScaleY: 'RPE：scaleYEvents',
    rpeTermColor: 'RPE：colorEvents',
    rpeTermText: 'RPE：textEvents',
    rpeTermIncline: 'RPE：inclineEvents',
    rpeTermPaint: 'RPE：paintEvents',
    rpeTermGif: 'RPE：gifEvents',
    headerNow: '当前 {value}',
    headerNowPair: '当前 {a} | {b}',
    headerSigma: 'Σ {value}',
    headerNotSet: '未设置',
    headerCrosses: '{sec} 秒穿过屏幕',
    headerCrossesNever: '音符不移动',
    headerFocused: '已聚焦：按 K 在此添加关键帧',
    headerFocusHint: '单击以聚焦此列（K、G 和 Ctrl+A 作用于它）',
    headerMenu: '列选项',
    headerPinnedFrom: '从 {line} 固定',
    headerUnpin: '取消固定此列',
    headerLinkOn: 'X 和 Y 已关联：在一个轴上添加、移动和删除关键帧时，另一个轴也会同步。单击以取消关联。',
    headerLinkOff: 'X 和 Y 未关联。单击以关联它们（之后一个轴上的关键帧会在另一个轴上同步）。',
    headerLinkLabelOn: 'X 和 Y 已关联',
    headerLinkLabelOff: 'X 和 Y 未关联',
    headerUsesLayers: '使用 {n} 个层级',
    headerUsesLayersHint:
      '此运动由 {n} 个层级相加。曲线显示它们的总和；编辑作用于基础层级。单击以查看各层级（完整模式）。',
    headerInUse: '已使用',
    headerInUseHint: '因为此判定线使用了它而显示（完整模式的属性）',
    headerSpeedBaked: '导出时烘焙',
    headerSpeedBakedHint: '导出时带曲线的流速会被转换为直线分段（经典流速模式）。',
    headerSpeed170: '1.7 流速',
    headerSpeed170Legacy: '1.7 流速（RPE < 1.7）',
    headerSpeed170Hint: 'RPE 1.7 流速曲线：速度跟随绘制的曲线。',
    headerSpeed170LegacyHint:
      'RPEVersion 低于 170 的 RPE 1.7 流速曲线：Phira 以旧方式对曲线积分（speed = k·f′(x) + b）。可在“项目设置”中更改。',
    headerExpand: '加宽显示此列',
    headerCompactLabel: '{prop}：加宽显示此列',
    headerAriaPinned: '{prop}，从 {line} 固定',
    headerAriaFocused: '{prop}，已聚焦：按 K 在此添加关键帧',
    headerAriaPinnedFocused: '{prop}，从 {line} 固定，已聚焦：按 K 在此添加关键帧',
    headerTooltip: '{prop} · {rpe} · {hint}',
    headerPreviewOnly: '已静音：仅影响预览',
    layerChip: '层{n}',
    layerChipNamed: '{name}',
    layerChipHas: '层级 {n}：有关键帧',
    layerChipEmpty: '层级 {n}：空',
    layerChipActive: '层级 {n}：正在编辑',
    layerChipMuted: '层级 {n}：已在预览中静音',
    layerChipSolo: '层级 {n}：在预览中独显',
    layerChipsLabel: '{prop}的层级',
    layerChipAria: '{label}：{state}',
    layerAdd: '添加层级',
    layerMenu: '层级 {n} 选项',
    layerRename: '重命名层级…',
    layerRenamePrompt: '层级 {n} 的名称',
    layerDelete: '删除层级',
    layerMute: '在预览中静音',
    layerUnmute: '取消静音',
    layerSolo: '在预览中独显',
    layerUnsolo: '取消独显',
    layerMoveHere: '将选中的区段移到这里',
    layerMutedNote: '仅影响预览：导出仍包含每个层级。',
    easeLinear: '线性',
    easeHold: '钩定（保持后跳变）',
    easeHoldShort: '钩定',
    easeBezier: '自定义曲线',
    easeBezierShort: 'Bz',
    easeId: '{id}',
    easeIdSlice: '{id} 部分',
    easeWords: '{strength}，{shape}',
    easeWordsSlice: '{strength}，{shape}（部分）',
    strengthGentle: '轻柔',
    strengthSoft: '柔和',
    strengthMedium: '适中',
    strengthStrong: '较强',
    strengthStronger: '更强',
    strengthExtreme: '极强',
    strengthSharp: '陡峭',
    strengthOvershoot: '过冲',
    strengthSpringy: '弹簧',
    strengthBouncy: '弹跳',
    shapeSlowStart: '慢起',
    shapeSlowEnd: '慢停',
    shapeSlowBoth: '两端慢',
    badgeIgnored: '已忽略',
    badgeIgnoredGuided: '曲线被忽略',
    badgeBaked: '烘焙',
    badgeBakedGuided: '导出时烘焙',
    badgeApprox: '≈ 拆分',
    badgeApproxGuided: '拆分 ≈ 0.1%',
    badgeTextSwitch: '切换',
    badgeTextTypeOn: '逐字显示',
    badgeTextErase: '擦除',
    badgeTextExtend: '扩展',
    badgeTextCounter: '计数器',
    notesHidden: '音符已隐藏（仍会判定）',
    ghostDefaultWhite: 'Phira 默认（白色）',
    ghostDefaultText: 'Phira 默认（空）',
    layerEmpty: '层级 {n} 为空。双击以添加关键帧。',
    lineGone: '此判定线已不存在。',
    rawPadding: '填充',
    rawSingle: '单个关键帧',
    rawTrailing: '末尾值',
    rawLead: '导入的开头',
    rawBakePiece: '烘焙分段',
    rawEasing: 'e{id}',
    rawEasingSlice: 'e{id} [{l}, {r}]',
    rawBezier: 'bezier {p}',
    rawLink: '绑定 {n}',
    rawValues: '{from} → {to}',
    valueText: '“{text}”',
    valueRgb: '[{r}, {g}, {b}]',
    valueNone: '-',
    listJoin: '{a} · {b}',
    unitPx: '{v}',
    unitDeg: '{v}°',
    unitPercent: '{v}%',
    unitSpeed: '{v}',
    unitThickness: '×{v}',
    unitRaw: '{v}',
    placeStart: '区段：再按 R 设置终点（数字 = 缓动），Esc 取消',
    placeStartHold: '钩定区段：按 R 设置终点，Esc 取消',
    placeBlocked: '中间有关键帧：请选择一段空闲的范围',
    placeTooShort: '终点必须在起点之后',
    placeNoColumn: '请先指向一个运动列（R 和 Q 在那里放置区段）',
    placeHintEnd: '结束区段',
    placeHintDigit: '按编号选择缓动（0.4 秒内输入两位数字）',
    placeHintCancel: '取消',
    dragHintLock: '锁定为单一轴',
    dragHintNoSnap: '不吸附',
    dragHintRound: '取整数值',
    dragHintCancel: '取消',
    dragReadout: '{beat} · {value}',
    cmdAddKey: '在播放头处添加关键帧',
    cmdAddKeyHint: '{keys} 在聚焦列的播放头处添加关键帧',
    cmdAddKeyAll: '为所有有动画的属性添加关键帧',
    cmdAddKeyAllHint: '{keys} 在播放头处为判定线所有有动画的属性添加关键帧',
    cmdAddKeyHere: '在此处添加关键帧',
    cmdDeleteKeys: '删除关键帧',
    cmdDeleteKeysHint: '{keys} 删除选中的关键帧',
    cmdNudgeValueUp: '增大关键帧的值',
    cmdNudgeValueDown: '减小关键帧的值',
    cmdNudgeTimeLater: '将关键帧后移',
    cmdNudgeTimeEarlier: '将关键帧前移',
    cmdNudgeValueUpHint: '{keys} 微调选中关键帧的值（Shift：10 步）',
    cmdSelectColumn: '选中此列的所有关键帧',
    cmdResetProperty: '重置属性',
    cmdSplitAtPlayhead: '在播放头处拆分',
    cmdHold: '钩定（保持后跳变）',
    cmdHoldHint: '{keys} 切换选中区段的钩定',
    cmdJump: '设为跳变 / 粘合',
    cmdJumpHint: '{keys} 设为跳变，或从前一个值粘合',
    cmdNegate: '数值取反',
    cmdNegateHint: '{keys} 将选中的值取反（不透明度：0%）',
    cmdOpacityFull: '不透明度 100%',
    cmdOpacityFullHint: '{keys} 将选中的不透明度关键帧设为 100%',
    cmdEasing: '更改缓动…',
    cmdEasingHint: '{keys} 为选中的区段打开缓动选择器',
    cmdLayerAdd: '添加层级',
    cmdLayerDelete: '删除层级',
    cmdLayerRename: '重命名层级',
    cmdLayerSetActive: '编辑层级…',
    cmdLayerMoveSelection: '将区段移到层级…',
    cmdLayerMute: '在预览中静音层级',
    cmdLayerSolo: '在预览中独显层级',
    cmdLayerUnmuteAll: '取消所有层级的静音',
    cmdToggleLink: '关联 X 和 Y 位置',
    cmdAddProperty: '添加属性…',
    cmdToggleSigma: '显示层级之和（Σ）',
    cmdLockRange: '锁定数值范围',
    cmdShowRaw: '显示原始事件',
    cmdCopyRaw: '将原始事件复制为 RPE JSON',
    cmdCopyCurve: '复制缓动',
    cmdPasteCurve: '粘贴缓动',
    cmdTemplates: '运动模板…',
    cmdClearPinned: '取消固定所有列',
    cmdPlaceSegment: '放置区段（R … R）',
    cmdPlaceSegmentHint: '在运动列上按 {keys} 开始一个区段；再按一次设置终点',
    cmdPlaceHold: '放置钩定区段（Q … R）',
    cmdPlaceDigit: '按编号设置区段缓动',
    cmdPlaceCancel: '取消放置区段',
    cmdFineTune: '微调数值',
    cmdFocusColumn: '聚焦列…',
    cmdPinColumn: '固定列',
    cmdUnpinColumn: '取消固定列',
    cmdCompare: '比较判定线',
    argProp: '属性',
    argLayer: '层级',
    argName: '名称',
    argDigit: '数字',
    argSteps: '步数',
    needProject: '请先打开一个项目',
    needFocus: '请先单击一个运动列',
    needActiveLine: '请先选择一条判定线',
    needKeys: '请先选中关键帧',
    needSegments: '请先选中区段（两个关键帧之间的曲线）',
    needOpacityKeys: 'S 将不透明度关键帧设为 100%；选中内容中没有不透明度关键帧',
    needNumeric: '只有数值关键帧才能这样跳变',
    needTwoLines: '请先在判定线面板中选中两条或更多判定线',
    needLayered: '只有位置、旋转、不透明度和流速有层级',
    needFullForLayers: '层级是完整模式的功能',
    needXyLine: '请先选择一条判定线',
    needCurve: '请先复制一个缓动',
    needMuted: '没有被静音的层级',
    needPinned: '没有固定的列',
    needPlacement: '当前没有正在放置的区段',
    layerLimit: '一个属性最多可以有 4 个层级',
    resetDone: '已重置{prop}。{absent}',
    linkedOn: '{line} 的 X 和 Y 位置已关联',
    linkedOff: '{line} 的 X 和 Y 位置已不再关联',
    curveCopied: '已复制缓动',
    curvePasted: '{count, plural, other {已将缓动粘贴到 # 个区段}}',
    rawCopied: '已复制原始事件',
    rawCopyFailed: '浏览器不允许复制',
    bakeAction: '烘焙',
    layerMutedToast: '{prop}的层级 {n} 已在预览中静音。导出不受影响。',
    layerSoloToast: '预览中只播放{prop}的层级 {n}。导出不受影响。',
    layerUnmutedAll: '所有层级恢复播放',
    layerDeleteConfirmTitle: '删除{prop}的层级 {n}？',
    layerDeleteConfirmBody: '它的 {count, plural, other {# 个关键帧}}将被移除。此操作可以撤销。',
    layerDeleteConfirm: '删除层级',
    guidedLayersTitle: '此运动使用了 {n} 个层级',
    guidedLayersBody: '该列显示它们的总和。可以在此编辑基础层级，或切换到完整模式查看每个层级。',
    guidedLayersBase: '编辑基础层级',
    guidedLayersFull: '切换到完整模式',
    compareStarted: '正在比较 {count, plural, other {# 条判定线}}的{prop}',
    compareClear: '取消固定',
    pinned: '已固定 {line} 的{prop}',
    unpinned: '已取消固定 {line} 的{prop}',
    addPropertyTitle: '添加属性',
    addPropertyBody: '选择要在 {line} 上添加动画的属性',
    comparePropTitle: '比较哪个属性？',
    focusPropTitle: '聚焦哪一列？',
    focusAddOption: '添加{prop}…',
    focusUnavailable: '{line} 上不能为{prop}添加动画',
    lineTypeNeeded: '此属性会改变判定线类型。请先使用“添加属性”进行更改。',
    lineTypeSkipped:
      '未向 {count, plural, other {# 条判定线}}添加{prop}：它会改变判定线类型。请先在那里使用“添加属性”。',
    templatesMulti: '模板已应用于 {line}。请对其他判定线再次运行。',
    txAddKey: '添加关键帧',
    txAddKeys: '添加关键帧',
    txMoveKeys: '移动 {count, plural, other {# 个关键帧}}',
    txDeleteKeys: '删除 {count, plural, other {# 个关键帧}}',
    txHold: '钩定',
    txMakeJump: '设为跳变',
    txContinue: '粘合',
    txNegate: '数值取反',
    txOpacityFull: '不透明度 100%',
    txEase: '更改缓动',
    txLayerAdd: '添加层级',
    txLayerDelete: '删除层级',
    txLayerRename: '重命名层级',
    txLayerMove: '移到层级 {n}',
    txLink: '关联 X 和 Y 位置',
    txUnlink: '取消关联 X 和 Y 位置',
    txReset: '重置{prop}',
    txAddProperty: '添加{prop}',
    txPlaceSegment: '放置区段',
    txFineTune: '微调数值',
    txNudge: '微调关键帧',
    txSplit: '在播放头处拆分',
    txPasteCurve: '粘贴缓动',
    helpColumnsTitle: '运动列',
    helpColumnsBody:
      '每个运动列显示当前判定线的一个属性如何随时间变化：时间向上推进，数值横向变化。单击一列将其聚焦，然后按 K 在播放头处添加关键帧。在列内双击可在不改变运动的情况下添加关键帧。拖动关键帧可修改其时间和数值（Shift 锁定一个轴，Alt 忽略吸附，Ctrl 取整数值）。选中两个关键帧之间的曲线，按 Enter 或 C 更改运动方式，按 H 设为“钩定”，按 J 设为跳变。',
    helpLayersTitle: '层级',
    helpLayersBody:
      '位置、旋转、不透明度和流速可以由多个层级相加（RPE 事件层级）。列上方的标签用于选择要编辑的层级；虚线曲线显示总和。静音和独显只影响预览：导出会保留每个层级，并有横幅提示预览与导出不同。',
    helpLinkTitle: 'X 和 Y 位置关联',
    helpLinkBody:
      'X 和 Y 位置关联后，在一个轴上添加、移动、删除、拆分关键帧或更改其缓动时，另一个轴在同一拍也会同样处理。数值保持各自独立。新判定线默认关联。',
    helpCompareTitle: '比较判定线',
    helpCompareBody:
      '“固定列”会把一列保留在当前判定线旁边。“比较判定线”会把每条选中判定线的同一属性并排固定，这样你可以同时拖动多条判定线的关键帧，并为它们统一应用缓动。',
    cmdDeleteSegments: '删除区段',
    cmdDeleteSegmentsHint: '{keys} 删除选中的区段（判定线保持在其起始值）',
    cmdSelectSegmentKeys: '选中区段的关键帧',
    headerUsesLayersShort: '{n}',
    layerChipCompact: '层{n}/{count}',
    layerChipsMenu: '层级 {n}，共 {count} 个：选择其他层级',
    tinyAlpha: '透明',
    tinyColor: '颜色',
    tinyGif: 'GIF',
    tinyIncline: '倾斜',
    tinyLength: '长度',
    tinyMoveX: 'X',
    tinyMoveY: 'Y',
    tinyPaint: '画笔',
    tinyPosition: '位置',
    tinyRotate: '旋转',
    tinySize: '尺寸',
    tinySizeX: 'W',
    tinySizeY: 'H',
    tinySpeed: '流速',
    tinyText: '文字',
    tinyThickness: '粗细',
    toastSegmentsAlreadyStay:
      '{count, plural, =1 {该区段已经} other {这些区段已经}}保持在起始值。请选中关键帧来删除它们。',
    toastSegmentsDeleted:
      '{count, plural, other {已删除 # 个区段}}：判定线保持在起始值{trimmed, plural, =0 {} other {（最后一个关键帧也被移除）}}',
    txDeleteSegments: '删除 {count, plural, other {# 个区段}}',
    needTwoKeys: '这里还没有区段：先添加两个关键帧（在两个拍上按 K），再单击它们之间的曲线',
  },
};

export default catalog;
